import { ReactNode } from "react";
import { AuthProvider } from "../context/AuthContext";

export default function AuthProviderWrapper({ children }: { children: ReactNode }) {
  if (process.env.NEXT_PUBLIC_E2E) return (<>{children}</>);
  return (
    <AuthProvider>
      {children}
    </AuthProvider>
  );
}
